import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';

class CartaPorteMercanciaGuiasIdentificacionForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      this.setState({
        data: { ...data },
        isValid: true
      });
    }
  }

  rules(data) {
    return {
      'NumeroGuiaIdentificacion': ['required', 'string'],
      'DescripGuiaIdentificacion': ['required', 'string', 'min:1', 'max:1000'],
      'PesoGuiaIdentificacion': ['required', 'string', 'min:0.001'],
    }
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    this.notifyFormDataChange(data);
  }

  notifyFormDataChange = (data) => {
    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes()
    });
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      isValid: false,
      guias: false,
      data: {}
    })
  }

  render() {
    const rules = this.rules();
    const { isValid, data = {} } = this.state;

    return (
      <>
        <Row>
          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Número Guia Identificación"
              name="NumeroGuiaIdentificacion"
              placeholder=""
              help=""
              minLength="10"
              maxLength="30"
              rules={ rules.NumeroGuiaIdentificacion }
              value={ data.NumeroGuiaIdentificacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="text"
              label="Descripción Guia Identificación"
              name="DescripGuiaIdentificacion"
              placeholder=""
              help=""
              minLength="1"
              maxLength="1000"
              rules={ rules.DescripGuiaIdentificacion }
              value={ data.DescripGuiaIdentificacion }
              onChange={ this.handleOnChange }
            />
          </Col>

          <Col sm md={ 4 }>
            <FormControl type="number"
              label="Peso Guia Identificación"
              name="PesoGuiaIdentificacion"
              placeholder=""
              help=""
              rules={ rules.PesoGuiaIdentificacion }
              value={ data.PesoGuiaIdentificacion }
              onChange={ this.handleOnChange }
            />
          </Col>
        </Row>

        <Row className="pt-3">
          <Col className="text-right">
            <Button variant="secondary"
              disabled={ !isValid }
              onClick={ this.handleOnAdd }
            >
              Agregar Guias de Identificación
            </Button>
          </Col>
        </Row>
      </>
    )
  }
}

export default CartaPorteMercanciaGuiasIdentificacionForm;